export * from './PropertyDetailsStandalone';
